/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";
export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'single',
    profile: {

        p_name_col_name: 'Item',

        p_description_col_name: 'Desc do Item',
        p_date_1_col_name: 'Data Doc',

        s_col_name: 'Fornecedor',

        showSupplierIdInSupplierNormalization: true,

        showBusinessUnitInSupplierNormalization: true,

        showSupplierVatInSupplierNormalization: true,

        synergyDashboardShowBusinessUnits: true,
        advancedDashboardShowGeoRegionFilter: true,
        showSupplierIdInAdvDashboard: true,

        locale: 'pt-br',
        currency: 'BRL',

        allowIncompleteTaxonomy: true,

        initialGroupBySupplierInactive: true, // Temporary for sample, needs to be reverted for full delivery (CAT-2838)

        ppvConfigEnabledColumns: [
            'part',
            'supplier',
            'business_unit', // Enabled for Compass
        ],

        supplierStandAloneFilter: '(default)', // See CAT-3590 before changing this
        disableSupplierNormalizationAiModel: true,

        hasFirestore: true,
        disableCommonSuppliersAdvDashboard: true, // For compass these switches didn't do anything
        disableCommonCategoryAdvDashboard: true, // For compass these switches didn't do anything

        branding: 'NExO',

        enableProcChat: true,
        enableGoldenRecord: true,
        enableSavingInitiativeTracker: true,
    },
}
